import script from "./loan.vue?vue&type=script&setup=true&lang=js"
export * from "./loan.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__